module.exports = __webpack_public_path__ + "img/video-icon.c336a040.png";